import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]查询公募基金高风险追加信息确认
 */
export function gmR5AdditionInfoUsingPOST(
  req: GmR5AddParam | void,
  config?: RequestConfig
): Promise<ApiResultRevisitVo> {
  return resource.postNoAuth('/revisit/gmR5/queryAdditionInfo', req, config);
}

/**
 * [No Auth]查询公募基金高风险回访问卷详情
 */
export function gmR5UsingPOST(req: void, config?: RequestConfig): Promise<ApiResultRevisitVo> {
  return resource.postNoAuth('/revisit/gmR5/queryDetails', req, config);
}

/**
 * 是否已回访
 */
export function isRevisitUsingPOST(req: LcRvisitDto | void, config?: RequestConfig): Promise<ApiResultint> {
  return resource.post('/revisit/isRevisit', req, config);
}

/**
 * 是否已回访-公募产品用
 */
export function isRevisitGMUsingPOST(req: LcRvisitDto | void, config?: RequestConfig): Promise<ApiResultGMRevistDto> {
  return resource.post('/revisit/isRevisitGM', req, config);
}

/**
 * 是否已回访-信托产品用
 */
export function isRevisitXTUsingPOST(req: LcRvisitDto | void, config?: RequestConfig): Promise<ApiResultRevisitReason> {
  return resource.post('/revisit/isRevisitXT', req, config);
}

/**
 * 查询基金投顾回访问卷详情
 */
export function jijintouguUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultRevisitVo> {
  return resource.post('/revisit/jijintougu/queryDetails', req, config);
}

/**
 * 查询未回访记录
 */
export function queryUsingPOST_2(req: void, config?: RequestConfig): Promise<ApiResultListPurchaseRecord> {
  return resource.post('/revisit/query', req, config);
}

/**
 * 查询问卷详情
 */
export function queryDetailsUsingPOST(
  req: LcFundAssetReturnDto | void,
  config?: RequestConfig
): Promise<ApiResultListRevisitVo> {
  return resource.post('/revisit/queryDetails', req, config);
}

/**
 * 回访
 */
export function revisitUsingPOST(req: LcFundAssetReturn | void, config?: RequestConfig): Promise<ApiResultboolean> {
  return resource.post('/revisit/revisit', req, config);
}

/**
 * 信托-下单后留痕
 */
export function saveReasonUsingPOST(req: LcProdClientRevisitDto, config?: RequestConfig): Promise<ApiResultboolean> {
  return resource.post('/revisit/saveReason', req, config);
}

/**
 * [No Auth]查询信托高风险追加信息确认
 */
export function xtR5AdditionInfoUsingPOST(
  req: ZgHighRiskParam | void,
  config?: RequestConfig
): Promise<ApiResultRevisitVo> {
  return resource.postNoAuth('/revisit/xtR5/queryAdditionInfo', req, config);
}

/**
 * [No Auth]信托高风险追加信息确认留痕
 */
export function xtR5SaveLeaveMarkUsingPOST(
  req: ZgHighRiskParam | void,
  config?: RequestConfig
): Promise<ApiResultboolean> {
  return resource.postNoAuth('/revisit/xtR5/saveLeaveMark', req, config);
}

/**
 * [No Auth]查询资管高风险追加信息确认
 */
export function zgR5AdditionInfoUsingPOST(
  req: ZgHighRiskParam | void,
  config?: RequestConfig
): Promise<ApiResultRevisitVo> {
  return resource.postNoAuth('/revisit/zgR5/queryAdditionInfo', req, config);
}

/**
 * [No Auth]资管高风险追加信息确认留痕
 */
export function zgR5SaveLeaveMarkUsingPOST(
  req: ZgHighRiskParam | void,
  config?: RequestConfig
): Promise<ApiResultboolean> {
  return resource.postNoAuth('/revisit/zgR5/saveLeaveMark', req, config);
}
